import { render, staticRenderFns } from "./ModalPropriedadesFreteCidade.vue?vue&type=template&id=3e70aada&scoped=true"
import script from "./ModalPropriedadesFreteCidade.vue?vue&type=script&lang=js"
export * from "./ModalPropriedadesFreteCidade.vue?vue&type=script&lang=js"
import style0 from "./ModalPropriedadesFreteCidade.vue?vue&type=style&index=0&id=3e70aada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e70aada",
  null
  
)

export default component.exports